import { render, staticRenderFns } from "./LocationInspection.vue?vue&type=template&id=0272712d"
import script from "./LocationInspection.vue?vue&type=script&lang=js"
export * from "./LocationInspection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports